import { gql } from '@apollo/client'

/**
 * Where a `runWorkflowStep` request is: `WAITING` until the step calls back,
 * then `COMPLETED` with its `outcome` and `data` (storefront COM-1294).
 *
 * `EXPIRED` is computed on read once a `WAITING` request is past `expiresAt`,
 * without a write. `TRIGGER_FAILED` is stored by the mutation, which also
 * answers 424, so a poller normally learns of it there first.
 *
 * Scoped to the session server-side: another session's request, or an
 * unknown one, answers `404` rather than `null`.
 *
 * ⚠️ `data` is `JSON` and must be selected as a leaf — a subselection is a
 * document-level validation failure. `tests/query.test.ts` pins it.
 * @internal
 */
const workflowStepRequestQuery = gql`
  query WorkflowStepRequest(
    $storefrontName: String!
    $sessionUid: String!
    $requestId: ID!
  ) {
    workflowStepRequest(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      requestId: $requestId
    ) {
      requestId
      status
      outcome
      data
      expiresAt
    }
  }
`

export default workflowStepRequestQuery
